import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\InboxController::show
* @see app/Http/Controllers/Creator/InboxController.php:36
* @route '/app/creator/inbox/{conversation}'
*/
export const show = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/app/creator/inbox/{conversation}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\InboxController::show
* @see app/Http/Controllers/Creator/InboxController.php:36
* @route '/app/creator/inbox/{conversation}'
*/
show.url = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { conversation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { conversation: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            conversation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        conversation: typeof args.conversation === 'object'
        ? args.conversation.uuid
        : args.conversation,
    }

    return show.definition.url
            .replace('{conversation}', parsedArgs.conversation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\InboxController::show
* @see app/Http/Controllers/Creator/InboxController.php:36
* @route '/app/creator/inbox/{conversation}'
*/
show.get = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::show
* @see app/Http/Controllers/Creator/InboxController.php:36
* @route '/app/creator/inbox/{conversation}'
*/
show.head = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::show
* @see app/Http/Controllers/Creator/InboxController.php:36
* @route '/app/creator/inbox/{conversation}'
*/
const showForm = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::show
* @see app/Http/Controllers/Creator/InboxController.php:36
* @route '/app/creator/inbox/{conversation}'
*/
showForm.get = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::show
* @see app/Http/Controllers/Creator/InboxController.php:36
* @route '/app/creator/inbox/{conversation}'
*/
showForm.head = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Creator\InboxController::reply
* @see app/Http/Controllers/Creator/InboxController.php:73
* @route '/app/creator/inbox/{conversation}/reply'
*/
export const reply = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reply.url(args, options),
    method: 'post',
})

reply.definition = {
    methods: ["post"],
    url: '/app/creator/inbox/{conversation}/reply',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\InboxController::reply
* @see app/Http/Controllers/Creator/InboxController.php:73
* @route '/app/creator/inbox/{conversation}/reply'
*/
reply.url = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { conversation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { conversation: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            conversation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        conversation: typeof args.conversation === 'object'
        ? args.conversation.uuid
        : args.conversation,
    }

    return reply.definition.url
            .replace('{conversation}', parsedArgs.conversation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\InboxController::reply
* @see app/Http/Controllers/Creator/InboxController.php:73
* @route '/app/creator/inbox/{conversation}/reply'
*/
reply.post = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reply.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::reply
* @see app/Http/Controllers/Creator/InboxController.php:73
* @route '/app/creator/inbox/{conversation}/reply'
*/
const replyForm = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reply.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::reply
* @see app/Http/Controllers/Creator/InboxController.php:73
* @route '/app/creator/inbox/{conversation}/reply'
*/
replyForm.post = (args: { conversation: string | { uuid: string } } | [conversation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reply.url(args, options),
    method: 'post',
})

reply.form = replyForm

const inbox = {
    show: Object.assign(show, show),
    reply: Object.assign(reply, reply),
}

export default inbox